import Feature from 'ol/Feature';
import { Point } from 'ol/geom';
import { Vector as VectorLayer } from 'ol/layer';
import { fromLonLat } from 'ol/proj';
import { Vector as VectorSource } from 'ol/source';

import { STYLES } from '@/define/olMaps';

/**
 * Shoot(촬영 지점) 관리 Feature
 */
class ShootFeature {
  constructor(map) {
    this.map = map;
    this.shoots = {};
  }

  /**
   * 촬영 지점 추가
   * @param {string} robotId - 로봇 ID
   * @param {Object} position - { lat, lng } 좌표
   */
  add(robotId, { lat, lng }) {
    const point = new Point(fromLonLat([lng, lat]));
    const feature = new Feature(point);

    // 후속 촬영 시
    if (this.shoots[robotId]) {
      this.shoots[robotId].getSource().addFeature(feature);
    }
    // 최초 촬영 시
    else {
      const source = new VectorSource({ features: [feature], wrapX: false });
      const layer = new VectorLayer({
        source,
        declutter: true,
        style: STYLES.SHOOT.POINT,
      });

      this.map.addLayer(layer);
      this.shoots[robotId] = layer;
    }
  }

  /**
   * 촬영 지점 제거
   * @param {string} robotId - 로봇 ID
   */
  remove(robotId) {
    if (!this.shoots[robotId]) return;

    this.map.removeLayer(this.shoots[robotId]);
    delete this.shoots[robotId];
  }

  /**
   * 촬영 데이터 가져오기
   * @param {string} robotId - 로봇 ID
   * @returns {VectorLayer|undefined} Shoot 레이어
   */
  get(robotId) {
    return this.shoots[robotId];
  }
}

export default ShootFeature;
